import { useEffect } from "react";
import { toasts } from "../utils/toasts";
import { useTranslation } from "react-i18next";

export type MutationResult = {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
};

export function useMutationToast(
  successText: string,
  failureText: string,
  result: MutationResult
) {
  const [t] = useTranslation();
  useEffect(() => {
    if (result.isSuccess) {
      toasts.success(t("operation.success"), successText);
    }

    if (result.isError) {
      toasts.danger(t("operation.failure"), failureText);
    }
  }, [result]);
}
